import React from 'react';
import '../../styles/CaseSummaries.css';

class CaseSummaryErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('Case summary view failed:', error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="page-container case-analysis-page">
          <div className="case-analysis-state-card">
            <h2>Case analysis could not be displayed</h2>
            <p>The rest of CaseDB is unaffected. Refresh this page to try loading the analysis again.</p>
            <button className="action" type="button" onClick={() => window.location.reload()}>Refresh</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default CaseSummaryErrorBoundary;
